export default __webpack_public_path__ + "static/media/rdstation-sendgrid-negative.cfe6c8fd.svg";